// Form step enum with numeric values
export const FORM_STEPS = {
  CASE_INFO: 1,
  LIABILITY: 2,
  MEDICAL_PROVIDERS: 3,
  PAIN_AND_SUFFERING: 4,
  ECONOMIC_DAMAGE: 5
};

// Step labels for display
export const STEP_LABELS = {
  [FORM_STEPS.CASE_INFO]: 'Case',
  [FORM_STEPS.LIABILITY]: 'Liability',
  [FORM_STEPS.MEDICAL_PROVIDERS]: 'Medical Providers',
  [FORM_STEPS.PAIN_AND_SUFFERING]: 'Pain & Suffering',
  [FORM_STEPS.ECONOMIC_DAMAGE]: 'Economic Damages'
};

// Helper to get next step
export const getNextStep = (currentStep) => {
  if (currentStep >= FORM_STEPS.ECONOMIC_DAMAGE) {
    return currentStep;
  }
  return currentStep + 1;
};

// Helper to get previous step
export const getPreviousStep = (currentStep) => {
  if (currentStep <= FORM_STEPS.CASE_INFO) {
    return currentStep;
  }
  return currentStep - 1;
};

// Helper to check if step is first
export const isFirstStep = (step) => {
  return step === FORM_STEPS.CASE_INFO;
};

// Helper to check if step is last
export const isLastStep = (step) => {
  return step === FORM_STEPS.ECONOMIC_DAMAGE;
};
